<div class="page">
    <main>
        <section>
            <div class="splide" style="height: 100%">
                <div class="splide__track">
                    <ul class="splide__list">
                        <li class="splide__slide"><img class="slide-image" src="assets/images/DSC00442.jpg"/></li>
                        <li class="splide__slide"><img class="slide-image" src="assets/images/H500F-1209.jpg"/></li>
                        <li class="splide__slide"><img class="slide-image" src="assets/images/hitec.jpg"/></li>
                        <li class="splide__slide"><img class="slide-image" src="assets/images/H203-AL-042.jpg"/></li>
                    </ul>
                </div>
            </div>
        </section>
        <section class="well center bg-color">
            <div class="container">
                <h3>{{"HOME.WELCOME" | translate }}</h3>
                <ul class="row product-list">
                    <li class="grid_3">
                    </li>
                    <li class="grid_6">
                        <p style="font-size: 19px">{{"HOME.INTRO" | translate }}</p>
                    </li>
                    <li class="grid_3">
                    </li>
                </ul>
            </div>
        </section>
        <section data-url="assets/images/parallax1.jpg" data-mobile="true" class="mobile-center parallax">
            <div class="videoWrapper">
                <iframe style="width: 100%; height: 60vh" src="https://www.youtube.com/embed/0qPtS8go1VE?controls=0"
                        frameborder="0" allowfullscreen></iframe>
            </div>
        </section>
        <section class="well1 center">
            <div class="container">
                <h3 style="word-wrap: break-spaces">{{"HOME.TOTEUTUKSET" | translate}}</h3>
                <div class="row off1">
                    <div class="grid_3" (click)="seurakunnat.open()"><a class="img"><img
                            class="square-image-home"
                            src="assets/images/1 seurakunnat.JPG"
                            alt=""><span>{{"USAGEGROUPS.SEURAKUNNAT.TITLE" | translate}}</span></a>
                    </div>
                    <div class="grid_3" (click)="kunnallistyot.open()"><a class="img"><img
                            class="square-image-home"
                            src="assets/images/2 kunnallistyöt.jpg"
                            alt=""><span>{{"USAGEGROUPS.KUNNALLISTYOT.TITLE" | translate}}</span></a>
                    </div>
                    <div class="grid_3" (click)="maaMetsa.open()"><a class="img"><img
                            class="square-image-home"
                            src="assets/images/3 maa- ja metsätalous.jpg"
                            alt=""><span>{{"USAGEGROUPS.MAAJAMETSATALOUS.TITLE" | translate}}</span></a>
                    </div>
                    <div class="grid_3" (click)="kiinteisto.open()"><a class="img"><img
                            class="square-image-home"
                            src="assets/images/4 kiinteistöjen kunnossapito.jpg"
                            alt=""><span>{{"USAGEGROUPS.KIINTEISTOJENKUNNOSSAPITO.TITLE" | translate}}</span></a>
                    </div>
                </div>
                <div class="row off2">
                    <div class="grid_3" (click)="energiaTieto.open()"><a class="img"><img
                            class="square-image-home"
                            src="assets/images/5 energia ja tietoliikenne.jpg"
                            alt=""><span>{{"USAGEGROUPS.ENERGIAJATIETOLIIKENNE.TITLE" | translate}}</span></a>
                    </div>
                    <div class="grid_3" (click)="teidenViherKunn.open()"><a class="img"><img
                            class="square-image-home"
                            src="assets/images/6 teiden ja viheralueiden kunnossapito.jpg"
                            alt=""><span>{{"USAGEGROUPS.TEIDENJAVIHERALUEIDEN.TITLE" | translate}}</span></a>
                    </div>
                    <div class="grid_3" (click)="maanpuolustus.open()"><a class="img"><img
                            class="square-image-home"
                            src="assets/images/7 maanpuolustus.jpg"
                            alt=""><span>{{"USAGEGROUPS.MAANPUOLUSTUS.TITLE" | translate}}</span></a>
                    </div>
                    <div class="grid_3" (click)="maanrakennus.open()"><a class="img"><img
                            class="square-image-home" src="assets/images/8 maanrakennus.jpg"
                            alt=""><span>{{"USAGEGROUPS.MAANRAKENNUS.TITLE" | translate}}</span></a>
                    </div>
                </div>

                <app-modal class="app-modal" #seurakunnat title="{{usageGroupsTranslation?.SEURAKUNNAT.TITLE}}"
                           description="{{usageGroupsTranslation?.SEURAKUNNAT.DESC}}"></app-modal>

                <app-modal class="app-modal" #kunnallistyot title="{{usageGroupsTranslation?.KUNNALLISTYOT.TITLE}}"
                           description="{{usageGroupsTranslation?.KUNNALLISTYOT.DESC}}"></app-modal>

                <app-modal class="app-modal" #maaMetsa title="{{usageGroupsTranslation?.MAAJAMETSATALOUS.TITLE}}"
                           description="{{usageGroupsTranslation?.MAAJAMETSATALOUS.DESC}}"></app-modal>

                <app-modal class="app-modal" #kiinteisto
                           title="{{usageGroupsTranslation?.KIINTEISTOJENKUNNOSSAPITO.TITLE}}"
                           description="{{usageGroupsTranslation?.KIINTEISTOJENKUNNOSSAPITO.DESC}}"></app-modal>

                <app-modal class="app-modal" #energiaTieto
                           title="{{usageGroupsTranslation?.ENERGIAJATIETOLIIKENNE.TITLE}}"
                           description="{{usageGroupsTranslation?.ENERGIAJATIETOLIIKENNE.DESC}}"></app-modal>

                <app-modal class="app-modal" #teidenViherKunn
                           title="{{usageGroupsTranslation?.TEIDENJAVIHERALUEIDEN.TITLE}}"
                           description="{{usageGroupsTranslation?.TEIDENJAVIHERALUEIDEN.DESC}}"></app-modal>

                <app-modal class="app-modal" #maanpuolustus title="{{usageGroupsTranslation?.MAANPUOLUSTUS.TITLE}}"
                           description="{{usageGroupsTranslation?.MAANPUOLUSTUS.DESC}}"></app-modal>

                <app-modal class="app-modal" #maanrakennus title="{{usageGroupsTranslation?.MAANRAKENNUS.TITLE}}"
                           description="{{usageGroupsTranslation?.MAANRAKENNUS.DESC}}"></app-modal>
            </div>
        </section>
    </main>
</div>
